import PerfectScrollbar from "perfect-scrollbar";
import 'perfect-scrollbar/css/perfect-scrollbar.css';
export default function PerfectScrollbarInit() {
	const table = document.querySelectorAll(".cover-table");
	if (table.length > 0) {
		table.forEach((table) => {
			new PerfectScrollbar(table, {
				wheelSpeed: 1,
				minScrollbarLength: 20,
				suppressScrollX: false,
				alwaysShowTracks: true,
				swipeEasing: true,
				clickRail: true
			});
		});
	}
}
